import gql from 'graphql-tag';

export const GENERATE_SURVEY_PROJECT_STATUS_REPORT = gql`
mutation generateSurveyProjectStatusReport($input: SurveyProjectGenericMutationInput!) {
    generateSurveyProjectStatusReport (input: $input){
    url
  }
}
`;

export const GENERATE_SURVEY_PROJECT_MANAGERS_REPORT = gql`
mutation generateSurveyProjectManagersReport($input: SurveyProjectGenericMutationInput!) {
    generateSurveyProjectManagersReport (input: $input){
    url
  }
}
`;

export default {
  GENERATE_SURVEY_PROJECT_STATUS_REPORT,
  GENERATE_SURVEY_PROJECT_MANAGERS_REPORT,
};
